// extracted by mini-css-extract-plugin
module.exports = {"root":"K1w50D","title":"V3vFiS","message":"c2iJ5N0","text":"c_5cwLD"};